import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { QuoteBand } from './components/QuoteBand';
import { ForYou } from './components/ForYou';
import { Outcomes } from './components/Outcomes';
import { Testimonials } from './components/Testimonials';
import { Includes } from './components/Includes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31aysc7e49y1x">
      <Header data-id="element-1" data-mp="31cjk5p91r2w3" />
      <main data-id="element-2" data-mp="2wka0gqyiyz29">
        <Hero data-id="element-3" data-mp="2wjqhr811w6n6" />
        <QuoteBand data-id="element-4" data-mp="2wiyuqllirh8i" />
        <ForYou data-id="element-5" data-mp="2wip6b2g4hi4x" />
        <Outcomes data-id="element-6" data-mp="2whxd1y9zzwht" />
        <Testimonials data-id="element-7" data-mp="28u5y0mx2p5cu" />
        <Includes data-id="element-8" data-mp="28tmdqzjya4vn" />
        <Bonuses data-id="element-9" data-mp="28t4ju9krg2qw" />
        <Pricing data-id="element-10" data-mp="28sl5f2ubjwhm" />
        <Guarantee data-id="element-11" data-mp="28s2ynca15zvg" />
        <Faq data-id="element-12" data-mp="23vkzqt1dsvr1" />
      </main>
      <Footer data-id="element-13" data-mp="23u9vks40xlze" />
    </div>;
}